import React, { FC, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useOutsideClick from "hooks/click-outside";
import { ReactComponent as Gallery } from "assets/images/svgs/ambassador/gallery-add.svg";
import { ReactComponent as Status } from "assets/images/svgs/ambassador/status-up.svg";
import { ReactComponent as Note } from "assets/images/svgs/ambassador/note-2.svg";
import { ReactComponent as Ranking } from "assets/images/svgs/ambassador/ranking.svg";
import { ReactComponent as Arrow } from "assets/images/svgs/ambassador/arrow-right.svg";

import SocialMediaActivity from "./SocialMediaActivity";
import NewPost from "./new-post";
import BusinessEngagement from "./bussiness-engagement";
import FamilyEngagement from "./family-engagement";
import EventSupport from "./event-support";
import useStore from "hooks/useStore";

interface PostActivityPopupProps {
  isOpen: boolean;
  handleConfirm: () => void;
  onClose: () => void;
}

const PostActivityPopup: FC<PostActivityPopupProps> = ({
  isOpen,
  onClose,
  handleConfirm,
}) => {
  const modalRef = useOutsideClick(onClose);

  const [showSocialPopup, setShowSocialPopup] = useState(false);
  const [showBusinessPopup, setShowBusinessPopup] = useState(false);
  const [showFamilyPopup, setShowFamilyPopup] = useState(false);
  const [showEventPopup, setShowEventPopup] = useState(false);
  const { getAmbassadorTierResposibilities } = useStore()
  const ambassadorTierResposibilities = getAmbassadorTierResposibilities();
  const activitySections = ambassadorTierResposibilities
    ? Object.keys(ambassadorTierResposibilities).filter((key) =>
      ["socialMedia", "businessEngagement", "familyEngagement","eventSupport"].includes(key)
    )
    : [];
  const handleSocialMediaClick = () => {
    setShowSocialPopup(true);
    onClose();
  };

  const handleBusinessEngagementClick = () => {
    setShowBusinessPopup(true);
    onClose();
  };

  const handleFamilyEngagementClick = () => {
    setShowFamilyPopup(true);
    onClose();
  };

  const handleEventSupportClick = () => {
    setShowEventPopup(true);
    onClose();
  };

  // const options = [
  //   {
  //     label: "Social Media Activity",
  //     icon: <Gallery />,
  //     onClick: handleSocialMediaClick,
  //   },
  //   {
  //     label: "Business Engagement",
  //     icon: <Status />,
  //     onClick: handleBusinessEngagementClick,
  //   },
  //   {
  //     label: "Family Engagement",
  //     icon: <Note />,
  //     onClick: handleFamilyEngagementClick,
  //   },
  //   {
  //     label: "Event Support",
  //     icon: <Ranking />,
  //     onClick: handleEventSupportClick,
  //   },
  // ];
  const activityLabels: Record<
    string,
    { label: string; icon: JSX.Element; onClick: () => void }
  > = {
    socialMedia: {
      label: "Social Media Activity",
      icon: <Gallery />,
      onClick: handleSocialMediaClick,
    },
    businessEngagement: {
      label: "Business Engagement",
      icon: <Status />,
      onClick: handleBusinessEngagementClick,
    },
    familyEngagement: {
      label: "Family Engagement",
      icon: <Note />,
      onClick: handleFamilyEngagementClick,
    },
    eventSupport: {
      label: "Event Support",
      icon: <Ranking />,
      onClick: handleEventSupportClick,
    },
  };
  const dynamicOptions = activitySections.map((key) => activityLabels[key]);
  
  


  if (
    !isOpen &&
    !showSocialPopup &&
    !showBusinessPopup &&
    !showFamilyPopup &&
    !showEventPopup
  )
    return null;

  return (
    <>
      {isOpen && (
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
        >
          <div
            ref={modalRef}
            className={`relative bg-white px-4 sm:px-6 py-6 sm:py-8 rounded-lg shadow-lg w-[90%] sm:w-[500px] md:w-[550px] transform transition-transform duration-300 ${
              isOpen ? "scale-100" : "scale-95"
            }`}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
            >
              <AiOutlineClose size={20} />
            </button>

            <h2 className="text-xl sm:text-2xl font-bold text-center mb-2 text-rsvpBlackie">
              Post Activity
            </h2>
            <p className="text-center text-sm sm:text-lg text-rsvpBlackie mb-6">
              Who would you like to share your post with?
            </p>

            <div className="space-y-3 mb-6">
              {dynamicOptions?.map((item, index) => (
                <button
                  key={index}
                  onClick={item.onClick}
                  className="w-full flex items-center justify-between bg-[#F5F5F5] px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl hover:bg-[#E5E5E5] transition"
                >
                  <div className="flex items-center space-x-2 sm:space-x-3">
                    <span className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">{item.icon}</span>
                    <span className="text-sm sm:text-lg text-rsvpBlackie">
                      {item.label}
                    </span>
                  </div>
                  <Arrow className="w-6 h-6 sm:w-8 sm:h-8 flex-shrink-0" />
                </button>
              ))}
            </div>
             <p className="text-center text-xs sm:text-sm text-[#DE9C27] font-medium pt-4">
                Earn {ambassadorTierResposibilities?.bonusPercentageOnCompletion}% bonus every month for completing a task from each category
              </p>
          </div>
        </div>
      )}

      {showSocialPopup && (
        <SocialMediaActivity
          isOpen={showSocialPopup}
          onClose={() => setShowSocialPopup(false)}
          handleConfirm={handleConfirm}
        />
      )}

      {showBusinessPopup && (
        <BusinessEngagement
          isOpen={showBusinessPopup}
          onClose={() => setShowBusinessPopup(false)}
          handleConfirm={handleConfirm}
        />
      )}

      {showFamilyPopup && (
        <FamilyEngagement
          isOpen={showFamilyPopup}
          onClose={() => setShowFamilyPopup(false)}
          handleConfirm={handleConfirm}
        />
      )}

      {showEventPopup && (
        <EventSupport
          isOpen={showEventPopup}
          onClose={() => setShowEventPopup(false)}
          handleConfirm={handleConfirm}
        />
      )}
    </>
  );
};

export default PostActivityPopup;
